var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"button",staticClass:"action-button interactive",class:[{ focus: _vm.focus, jump: _vm.jump, disabled: _vm.disabled }, _vm.variation, _vm.size]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }